import {
  AppBar,
  Toolbar,
  Box,
} from "@mui/material";
import FeatureSearch from "./FeatureSearch";

// Light theme colors for the topbar
const TOPBAR_BG = "#ffffff";
const TOPBAR_TEXT = "var(--text-1, #1a1a2e)";
const TOPBAR_BORDER = "var(--light-grey, #e8e8e8)";
const SEARCH_BG = "#f4f4f5";
const SEARCH_HOVER_BG = "#e5e7eb";

// ─── Component ────────────────────────────────────────────────────────────────

const SubscribedTopbar = () => {
  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        backgroundColor: TOPBAR_BG,
        borderBottom: "1px solid",
        borderColor: TOPBAR_BORDER,
        color: TOPBAR_TEXT,
        zIndex: (t) => t.zIndex.drawer + 1, // Stay above the drawer
      }}
    >
      <Toolbar
        sx={{
          minHeight: { xs: 56, sm: 56 },
          px: { xs: 1.5, sm: 2 },
          gap: 1,
        }}
      >
        {/* ── Left: Empty spacer to keep search centered if needed, or remove ── */}
        <Box sx={{ width: { xs: 0, sm: 224 }, flexShrink: 0 }} />


        {/* ── Center: global search ── */}
        <Box sx={{ flex: 1, maxWidth: 520, mx: "auto" }}>
          <FeatureSearch />
        </Box>

        {/* ── Right: empty to balance the layout if needed, or remove ── */}
        <Box sx={{ width: { xs: 0, sm: 224 }, flexShrink: 0 }} />
      </Toolbar>
    </AppBar>
  );
};

export default SubscribedTopbar;
